import moment from "moment";
import PromoCodeApi from "@/services/api/promoCodeApi.js";
import { PromoCodeTypes, getCodeObjectFromValue } from "../../../../services/PromoCodeTypes";

const PromoCodeApiService = new PromoCodeApi();

export default {
  inject: ["$validator"],
  provide() {
    return { parentValidator: this.$validator };
  },
  props: ["code"],

  data() {
    return {
      codeTypes: PromoCodeTypes,
      request_started: false,
      select_attribute: {
        highlight: {
          backgroundColor: "#FFF500",
          borderColor: "#FFF500",
        },
        contentStyle: {
          color: "black",
          backgroundColor: "#FFF500",
        },
      },
      theme_styles: {
        dayCellNotInMonth: {
          opacity: 0.5,
        },
      },
      model: {
        type: getCodeObjectFromValue("AMOUNT") || "AMOUNT",
        start_date: new Date(),
        end_date: null,
        promo_code: "",
        amount: "",
        ongoing_indefinite: true,
        one_time_use: true,
        first_order_only: false,
        minimum_cart_value: "",
      },
    };
  },
  mounted() {
    if (this.code) {
      this.getCode();
    }
  },
  watch: {
    "model.end_date": function (endDate) {
      if (endDate === null) {
        this.model.ongoing_indefinite = true;
      } else {
        this.model.ongoing_indefinite = false;
      }
    },
  },
  computed: {
    hasPromoCodeExpired() {
      return moment(this.model.start_date).isBefore(moment());
    },
  },

  methods: {
    getCode,
    validate,
    submit,
    reset,
    close,
    handleSelectChange,
    transformForFreeShipping,
    handleOngoingClick() {
      if (!this.model.ongoing_indefinite) {
        this.model.end_date = null;
      }
    },
  },
};

function handleSelectChange(value) {
  this.model.type = value;
}

function getCode() {
  PromoCodeApiService.getPromoCode(this.code)
    .then(({ data }) => {
      const obj = data;
      obj.start_date = new Date(obj.start_date);
      obj.type = getCodeObjectFromValue(obj.type);
      this.model = obj;
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

function reset() {
  this.model = {
    type: "AMOUNT",
    start_date: new Date(),
    end_date: null,
    promo_code: "",
    amount: "",
    one_time_use: true,
    first_order_only: false,
    minimum_cart_value: "",
  };
}

function validate() {
  this.$validator.validate().then((valid) => {
    if (!valid) {
      return;
    }
    this.submit();
  });
}

function submit() {
  if (this.request_started) {
    return;
  }

  this.request_started = true;
  let request = null;

  this.transformForFreeShipping();

  const method = this.code ? PromoCodeApiService.update : PromoCodeApiService.create;

  if (this.code) {
    request = {
      id: this.code,
      code: this.model.promo_code,
      type: this.model.type.value,
      amount: this.model.amount,
      minimum_cart_value: this.model.minimum_cart_value ? this.model.minimum_cart_value : null,
      start_date: this.$moment(this.model.start_date).format("YYYY-MM-DD"),
      end_date: this.model.end_date ? this.$moment(this.model.end_date).format("YYYY-MM-DD") : null,
      ongoing_indefinite: this.model.ongoing_indefinite,
    };
  } else {
    request = {
      ...this.model,
      type: this.model.type.value,
      ongoing_indefinite: this.model.ongoing_indefinite,
    };

    request.start_date = this.$moment(request.start_date).format("YYYY-MM-DD");
    request.end_date ? (request.end_date = this.$moment(request.end_date).format("YYYY-MM-DD")) : null;
  }

  method(request)
    .then(() => {
      this.$swal("Success", "Promo code successfully saved");
      this.$emit("close-create-promo-code-modal", true);
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    })
    .finally(() => {
      this.request_started = false;
    });
}

function transformForFreeShipping() {
  if (this.model.type?.value !== "AMOUNT") {
    this.model.amount = 0;
  }
}

function close() {
  this.$emit("close-create-promo-code-modal");
}
